import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const UserProfileCircle = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M4.16667 15C5.04904 13.5262 6.9829 12.5175 10 12.5175C13.0171 12.5175 14.951 13.5262 15.8333 15M17.9999 10C17.9999 14.4183 14.4182 18 9.99992 18C5.58164 18 1.99992 14.4183 1.99992 10C1.99992 5.58174 5.58164 2.00002 9.99992 2.00002C14.4182 2.00002 17.9999 5.58174 17.9999 10ZM12.3966 7.4C12.3966 8.72548 11.3236 9.8 10 9.8C8.67637 9.8 7.60336 8.72548 7.60336 7.4C7.60336 6.07452 8.67637 5 10 5C11.3236 5 12.3966 6.07452 12.3966 7.4Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    )
  },
)

export default UserProfileCircle
